module.exports = __webpack_public_path__ + "static/media/trofeus (3).5975500b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Trofeus/trofeus (3).jpg
// module id = 367
// module chunks = 0